<template>
  <MainLayout>
    <ReservationDetail />
  </MainLayout>
</template>

<script>
import MainLayout from '@/layouts/MainLayout.vue';
import ReservationDetail from '@/components/reserve/ReservationDetail.vue';

export default {
  name: 'ReservationDetailView',
  components: {
    MainLayout,
    ReservationDetail,
  },
};
</script>
